import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoginService } from './core/services/login.service';
import { SignalrService } from './core/services/signalr.service';
import { SearchStateService } from './core/services/search-state.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('frakcio-monitoring');

  constructor() {
    const loginService = inject(LoginService);
    const signalrService = inject(SignalrService);

    // fuerza la instanciación para que el pipeline de QR inicie,
    // de esta manera ya escucha si el servicio de signalr recibe un mensaje aunque el usuario no esté en la pantalla de búsqueda
    inject(SearchStateService);

    // Iniciar la conexión de SignalR si el usuario ya está autenticado al cargar la aplicación
    if (loginService.isAuthenticated()) {
      signalrService.startConnection(loginService.getMiddlewareInfo().ip);
    }
  }
}
